var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "modal",
    {
      attrs: {
        "backbone-dismiss-modal": true,
        title: _vm.$t("general.contact_us"),
      },
    },
    [
      _c(
        "div",
        { staticClass: "flex-container column" },
        [
          _c("p", [
            _vm._v(_vm._s(_vm.$t("general.chat_with_us")) + " (9am-6pm ET)"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex-container" }, [
            _c("div", { staticClass: "flex-container column" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-large btn-primary btn-moon",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.clickedSupportChat.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("general.support")) +
                      "\n        "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "flex-container column" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-large btn-primary btn-moon",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.clickedSalesChat.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("general.sales")) +
                      "\n        "
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("modal-divider"),
          _vm._v(" "),
          _c("div", [
            _vm._v("\n      " + _vm._s(_vm.$t("general.email_us")) + ": "),
            _c("a", { attrs: { href: "mailto:support@codecombat.com" } }, [
              _vm._v("support@codecombat.com"),
            ]),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }